import orderApi from '../../api/order'
import * as types from '../mutation-types'

// initial state
const state = {
  orders: [],
  pageSize: 10,
  pageIndex: 1,
  maxPageSize: 1,
  beginTime: '',// 起始时间
  endTime: '',// 结束时间
  businesslineIds: '', // 业务线id
  orderNodeIds: '', // 订单状态
  matchingFields: '',// 平台订单id或业务订单id或手机号
  customerLabelIds: "", // 客户标签
  dataType: '', // 数据类型
  businessType: "", // 业务状态
  checkType:""
}

// getters
const getters = {
  orders: (state) => state.orders,
  isOrderPageEnd: (state) => state.pageIndex >= state.maxPageSize,
  beginTime: (state) => state.beginTime,
  endTime: (state) => state.endTime,
  businesslineIds: (state) => state.businesslineIds,
  orderNodeIds: (state) => state.orderNodeIds,
  matchingFields: (state) => state.matchingFields,
  customerLabelIds: (state) => state.customerLabelIds,
  dataType: (state) => state.dataType,
  businessType: (state) => state.businessType,
  checkType: (state) => state.checkType,
};
// mutations
const mutations = {
  // 设置订单列表
  [types.RECEIVE_ORDER_LIST](state, { list }) {
    state.orders = list
  },
  // 追加订单列表
  [types.APPEND_ORDER_LIST](state, { list }) {
    if (list && list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        state.orders.push(list[i])
      }
    }
    console.log('追加订单列表', list)
  },
  // 设置最大页数
  [types.SET_ACCOUNT_ORDERS_MAXPAGESIZE](state, { pageCount }) {
    state.maxPageSize = pageCount
  },
  // 设置当前页数
  [types.SET_ACCOUNT_ORDERS_PAGEINDEX](state, { pageIndex }) {
    state.pageIndex = pageIndex
  },
  // 显示订单应发佣金流程
  CHANGE_ORDER_COMMISSION_STATE(state, id) {
    state.orders.forEach((item) => {
      item.isShowDelayCommission = false;
      item.isShowDelayReward = false;
      item.isShowReward = false
      item.isShowOrderState = false
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowCommission = !item.isShowCommission
      } else {
        item.isShowCommission = false
      }
    });
  },
  // 显示订单延迟应发佣金流程
  CHANGE_ORDER_DELAY_COMMISSION_STATE(state, id) {
    state.orders.forEach((item) => {
      item.isShowCommission = false;
      item.isShowReward = false
      item.isShowDelayReward = false;
      item.isShowOrderState = false
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowDelayCommission = !item.isShowDelayCommission
      } else {
        item.isShowDelayCommission = false
      }
    });
  },
  // 显示订单实发佣金流程
  CHANGE_ORDER_REWARD_STATE(state, id) {
    state.orders.forEach((item) => {
      item.isShowCommission = false
      item.isShowDelayCommission = false;
      item.isShowDelayReward = false;
      item.isShowOrderState = false
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowReward = !item.isShowReward;
      } else {
        item.isShowReward = false;
      }
    });
  },
  // 显示订单实发佣金流程
  CHANGE_ORDER_DELAY_REWARD_STATE(state, id) {
    state.orders.forEach((item) => {
      item.isShowCommission = false
      item.isShowDelayCommission = false
      item.isShowReward = false;
      item.isShowOrderState = false
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowDelayReward = !item.isShowDelayReward;
      } else {
        item.isShowDelayReward = false;
      }
    });
  },
  // 显示订单下单经销商
  CHANGE_ORDER_DEALER_STATE(state, id) {
    state.orders.forEach((item) => {
      item.isShowCommission = false;
      item.isShowDelayCommission = false;
      item.isShowReward = false;
      item.isShowDelayReward = false;
      item.isShowOrderState = false;
      if (item.orderID === id) {
        item.isShowDealer = !item.isShowDealer;
      } else {
        item.isShowDealer = false;
      }
    });
  },
  // 改变订单流程状态
  CHANGE_ORDER_STEP_STATE(state, id) {
    state.orders.forEach((item) => {
      item.isShowCommission = false
      item.isShowDelayCommission = false;
      item.isShowReward = false
      item.isShowDelayReward = false;
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowOrderState = !item.isShowOrderState
      } else {
        item.isShowOrderState = false
      }
    });
  },
  // 显示应发原因
  CHANGE_ORDER_POPOVER(state, id) {
    state.orders.forEach(item => {
      if (item.orderID === id) {
        item.isShowPopover = !item.isShowPopover
      } else {
        item.isShowPopover = false
      }
    });
  },
  // 追加订单状态数据
  CHANGE_ORDER_STEP_LIST(state, obj) {
    state.orders.forEach(item => {
      if (item.orderID === obj.orderId) {
        item.orderStepList = obj.list
      }
    });
  },
  SET_SEARCH_TIME(state, payload) {
    state.beginTime = payload.beginTime
    state.endTime = payload.endTime
  },
  SET_SEARCH_ORDER_NODE(state, payload) {
    state.orderNodeIds = payload.orderNodeIds
    state.customerLabelIds = payload.customerLabelIds
    state.dataType = payload.dataType
    state.businesslineIds = payload.businesslineIds
    state.businessType = payload.businessType
  },
  SET_SEARCH_ORDERID(state, payload) {
    state.matchingFields = payload.matchingFields
    state.checkType = payload.checkType;
  },

}

// actions
const actions = {
  async getOrders({ commit, getters }) {
    commit(types.SET_ACCOUNT_ORDERS_PAGEINDEX, { pageIndex: 1 })
    let reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/;
    let res1 = await orderApi.getOrders({
      beginTime: getters.beginTime,
      endTime: getters.endTime,
      businesslineIds: getters.businesslineIds,
      orderNodeIds: getters.orderNodeIds,
      matchingFields: getters.matchingFields,
      customerLabelIds: getters.customerLabelIds,
      businessType: getters.businessType,
      checkType: getters.checkType,
      dataType: state.dataType,
      pageSize: state.pageSize,
      pageIndex: state.pageIndex,
    });
    commit(types.SET_ACCOUNT_ORDERS_MAXPAGESIZE, {
      pageCount: res1.data.result.list.pageCount
    });
    if (getters.matchingFields) {
      let res2 = await orderApi.getOrders({
        beginTime: getters.beginTime,
        endTime: getters.endTime,
        businesslineIds: getters.businesslineIds,
        orderNodeIds: getters.orderNodeIds,
        customerLabelIds: getters.customerLabelIds,
        businessType: getters.businessType,
        checkType: getters.checkType,
        matchingFields: getters.matchingFields.replace(reg, "$1****$2"),
        dataType: state.dataType,
        pageSize: state.pageSize,
        pageIndex: state.pageIndex,
      });
      var data = res1.data.result.list.orders.concat(res2.data.result.list.orders)
      const uniqueOrdersMap = new Map();
      data.forEach(item => {
        if (!uniqueOrdersMap.has(item.orderID)) {
          uniqueOrdersMap.set(item.orderID, item);
        }
      });
      // 将 Map 转换回数组
      var list = Array.from(uniqueOrdersMap.values());
    } else {
      var list = res1.data.result.list.orders
    }
    let newList = list.map(item => {
      let newDealerList = item.dealerList.map((item1) => {
        return {
          ...item1,
          isShowDetail: false,
        };
      });
      return {
        ...item,
        dealerList: newDealerList,
        isShowOrderState: false,
        isShowCommission: false,
        isShowDealer: false,
        isShowReward: false,
        orderStepList: [],
        isShowPopover: false,
        isShowDelayCommission: false,
        isShowDelayReward: false,
      };
    })
    commit(types.RECEIVE_ORDER_LIST, { list: newList })
  },
  // 加载更多
  async loadMoreOrders({ commit, getters }) {
    const pageNo = state.pageIndex + 1
    commit(types.SET_ACCOUNT_ORDERS_PAGEINDEX, { pageIndex: pageNo })
    let reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/;
    let res1 = await orderApi.getOrders({
      beginTime: getters.beginTime,
      endTime: getters.endTime,
      businesslineIds: getters.businesslineIds,
      orderNodeIds: getters.orderNodeIds,
      customerLabelIds: getters.customerLabelIds,
      matchingFields: getters.matchingFields,
      businessType: getters.businessType,
      checkType: getters.checkType,
      dataType: state.dataType,
      pageSize: state.pageSize,
      pageIndex: state.pageIndex,
    });

    if (getters.matchingFields) {
      let res2 = await orderApi.getOrders({
        beginTime: getters.beginTime,
        endTime: getters.endTime,
        businesslineIds: getters.businesslineIds,
        orderNodeIds: getters.orderNodeIds,
        customerLabelIds: getters.customerLabelIds,
        businessType: getters.businessType,
        checkType: getters.checkType,
        matchingFields: getters.matchingFields.replace(reg, "$1****$2"),
        dataType: state.dataType,
        pageSize: state.pageSize,
        pageIndex: state.pageIndex,
      });
      var data = res1.data.result.list.orders.concat(
        res2.data.result.list.orders
      );
      const uniqueOrdersMap = new Map();
      data.forEach(item => {
        if (!uniqueOrdersMap.has(item.orderID)) {
          uniqueOrdersMap.set(item.orderID, item);
        }
      });
      // 将 Map 转换回数组
      var list = Array.from(uniqueOrdersMap.values());
    } else {
      var list = res1.data.result.list.orders
    }
    let newList = list.map(item => {
      let newDealerList = item.dealerList.map((item1) => {
        return {
          ...item1,
          isShowDetail: false,
        };
      });
      return {
        ...item,
        dealerList: newDealerList,
        isShowOrderState: false,
        isShowCommit: false,
        isShowReward: false,
        isShowDealer: false,
        orderStepList: [],
        isShowPopover: false,
        isShowDelayCommission: false,
        isShowDelayReward: false,
      };
    })
    commit(types.APPEND_ORDER_LIST, { list: newList })
  },
  // 设置查询订单时间
  setSearchTime({ commit }, payload) {
    commit('SET_SEARCH_TIME', payload)
    return this.dispatch('getOrders', { commit, getters })
  },
  // 设置查询订单节点
  setSearchOrderNode({ commit }, payload) {
    commit('SET_SEARCH_ORDER_NODE', payload)
    return this.dispatch('getOrders', { commit, getters })
  },
  // 设置查询订单id
  setSearchOrder({ commit }, payload) {
    commit('SET_SEARCH_ORDERID', payload)
    return this.dispatch('getOrders', { commit, getters })
  },
}

export default {

  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/orders.js